import Clickable from "../Clickable";

type OwnProps = {
  id?: string;
  title: React.ReactNode | string;
  onClick?: $TSFixMeFunction;
  target?: string;
  className?: string;
  focus?: boolean;
};

const defaultProps: Partial<OwnProps> = {
  id: undefined,
  onClick: undefined,
  target: undefined,
  className: "breadcrumb-item",
  focus: false,
};

type Props = OwnProps & typeof defaultProps;

function BreadcrumbItem({
  id,
  title,
  onClick,
  target,
  className,
  focus,
}: Props) {
  return (
    <div
      id={id}
      className={focus ? `${className} breadcrumb-focus` : className}
    >
      {onClick || target ? (
        <Clickable onClick={onClick} target={target}>
          {title}
        </Clickable>
      ) : (
        <div>{title}</div>
      )}
    </div>
  );
}

BreadcrumbItem.defaultProps = defaultProps;

export default BreadcrumbItem;
